import "./searchCompGeneral.scss";

function SearchCompGeneral({ handleSubmit , loadingResult , setSearchValue , searchValue , searchBtnColorActive , searchBtnColorInActive , btnTextColor , isDisabled = false , 
  placeholder = 'ابحث عن رقم وظيفي أو اسم', moreWidthForTheSearchComp = false
}) {
  return (
    <>
     <form onSubmit={handleSubmit}>
      <div className={`manage_data_search_part ${moreWidthForTheSearchComp && "more_width"}`}>
        <input type="text" placeholder={ placeholder } className="manage_data_search_part_inp" dir="rtl" value={searchValue} onChange={(e)=>{setSearchValue(e.target.value)}} />
        <button type="submit"
         style={ loadingResult ? { backgroundColor: searchBtnColorInActive , color: btnTextColor } : { backgroundColor: searchBtnColorActive , color: btnTextColor } } 
         className={loadingResult ? "manage_data_search_part_btn btn_LoadingToSeach_data" : "manage_data_search_part_btn" } 
         disabled={ isDisabled }
         >
         {loadingResult ? <>يتم البحث </> : <>ابحث</>}
        </button>
      </div>
     </form>
    </>
  )
}

export default SearchCompGeneral;